module.exports = __webpack_public_path__ + "img/arrow.c5d07a70.svg";